import { Carousel, Button, ButtonToolbar, ButtonGroup } from 'react-bootstrap';
import * as _ from 'lodash';
import * as React from 'react';

import { Formatters } from '../../common/formatters';
import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';

export const RegionalComponentListDetailFormComponentDetailsResearch = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,
    formData,
    inventoryResearch,
    defaultInputProps,
    sectionTitle,
    showAdd,
    handleNewResearchButton,
    handleDeleteResearchButton,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    const inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    const inputPropsSmallWidthNumberInput = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colInputXs: 3,
    });

    let inputPropsMedWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        colInputXs: 4,
    });

    const inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 4,
        colInputXs: 7,
    });

    const inputPropsTextAreaDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 4,
        colInputXs: 8,
    });

    let carouselItems = _.stubArray();

    if (_.size(inventoryResearch)) {
        carouselItems = _.map(inventoryResearch, (c, i) => {
            const researchId = _.get(c, 'researchId', 0);

            return (
                <Carousel.Item key={`research-history-researchId-${researchId}`}>
                    <div>
                        <div>
                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.researchDate"
                                label={appText('research-history.research-date')}
                                value={Formatters.formatDateShortDate(_.get(c, 'date'))}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.projectDate"
                                label={appText('research-history.project-date')}
                                value={Formatters.formatDateShortDate(_.get(c, 'projectDate'))}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.researchContactName"
                                label={appText('research-history.contact-name')}
                                value={Formatters.composeUsernameLabel(c, false)}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.researchContactCompany"
                                label={appText('research-history.company')}
                                value={Formatters.getStr(c, 'contact.company')}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.researchContactPhone"
                                label={appText('research-history.phone')}
                                value={Formatters.formatPhoneNumber(Formatters.getStr(c, 'contact.phone'))}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.researchedUL"
                                label={appText('research-history.researched-ul')}
                                value={Formatters.getInt(c, 'usefulLife')}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.researchedBestCost"
                                label={appText('research-history.researched-best-cost')}
                                value={Formatters.formatCurrencyIntl(Formatters.getFloat(c, 'bestCost'))}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.researchedWorstCost"
                                label={appText('research-history.researched-worst-cost')}
                                value={Formatters.formatCurrencyIntl(Formatters.getFloat(c, 'worstCost'))}
                                {...inputProps}
                            />

                            <KendoWrappers.KendoDisabledInputHidden
                                name="_researchHistory.researchedNotes"
                                label={appText('research-history.research-notes')}
                                value={Formatters.getStr(c, 'notes')}
                                {...inputProps}
                            />
                        </div>

                        <DetailFormCommon.InventoryDetailFormSectionSpacing />

                        <div>
                            <ButtonGroup>
                                <Button bsSize="sm" bsStyle="danger" onClick={e => { handleDeleteResearchButton(e, c); }}>
                                    <i className="glyphicon glyphicon-trash" /> {appText('buttons.delete-research')}
                                </Button>
                            </ButtonGroup>
                        </div>
                    </div>
                </Carousel.Item>
            );
        });
    }

    carouselItems.push((
        <Carousel.Item key={`research-history-researchId-addNew`}>
            <div>
                <KendoWrappers.KendoDateInput
                    name="addResearch.researchDate"
                    clearable={true}
                    label={appText('research-history.research-date')}
                    value={Formatters.formatDateForKendoDateInput(_.get(formData, 'addResearch.researchDate'))}
                    {...inputProps}
                />

                <KendoWrappers.KendoDateInput
                    name="addResearch.projectDate"
                    clearable={true}
                    label={appText('research-history.project-date')}
                    value={Formatters.formatDateForKendoDateInput(_.get(formData, 'addResearch.projectDate'))}
                    {...inputProps}
                />

                <KendoWrappers.KendoTextInputDebounced
                    name="addResearch.researchContactFirstName"
                    label={appText('research-history.contact-first-name')}
                    value={Formatters.getStr(formData, 'addResearch.researchContactFirstName')}
                    placeholder={appText('research-history.contact-first-name.placeholder')}
                    disableWrapper={false}
                    maxLength={50}
                    {...inputPropsMedWidthTextDebounced}
                />

                <KendoWrappers.KendoTextInputDebounced
                    name="addResearch.researchContactLastName"
                    label={appText('research-history.contact-last-name')}
                    placeholder={appText('research-history.contact-last-name.placeholder')}
                    value={Formatters.getStr(formData, 'addResearch.researchContactLastName')}
                    disableWrapper={false}
                    maxLength={50}
                    {...inputPropsMedWidthTextDebounced}
                />

                <KendoWrappers.KendoTextInputDebounced
                    name="addResearch.researchContactCompany"
                    label={appText('research-history.company')}
                    placeholder={appText('research-history.company.placeholder')}
                    value={Formatters.getStr(formData, 'addResearch.researchContactCompany')}
                    disableWrapper={false}
                    maxLength={50}
                    {...inputPropsMedWidthTextDebounced}
                />

                <KendoWrappers.KendoTextInputDebounced
                    name="addResearch.researchContactPhone"
                    label={appText('research-history.phone')}
                    placeholder={appText('research-history.phone.placeholder')}
                    value={Formatters.getStr(formData, 'addResearch.researchContactPhone')}
                    disableWrapper={false}
                    maxLength={50}
                    {...inputPropsMedWidthTextDebounced}
                />

                <KendoWrappers.KendoNumberInput
                    name="addResearch.researchResearchedUL"
                    label={appText('research-history.researched-ul')}
                    format="###"
                    placeholder="# Years"
                    disableWrapper={false}
                    value={Formatters.getInt(formData, 'addResearch.researchResearchedUL')}
                    {...inputPropsSmallWidthNumberInput}
                />

                <KendoWrappers.KendoCurrencyInput
                    name="addResearch.researchResearchedBestCost"
                    label={appText('research-history.researched-best-cost')}
                    value={Formatters.getFloat(formData, 'addResearch.researchResearchedBestCost')}
                    placeholder="$0.00"
                    disableWrapper={false}
                    {...inputPropsSmallWidthNumberInput}
                />

                <KendoWrappers.KendoCurrencyInput
                    name="addResearch.researchResearchedWorstCost"
                    label={appText('research-history.researched-worst-cost')}
                    value={Formatters.getFloat(formData, 'addResearch.researchResearchedWorstCost')}
                    placeholder="$0.00"
                    disableWrapper={false}
                    {...inputPropsSmallWidthNumberInput}
                />

                <KendoWrappers.KendoTextareaDebounced
                    name="addResearch.researchResearchNotes"
                    label={appText('research-history.research-notes')}
                    rows={4}
                    value={Formatters.getStr(formData, 'addResearch.researchResearchNotes')}
                    {...inputPropsTextAreaDebounced}
                />

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <ButtonGroup>
                        <Button bsSize="sm" bsStyle="success" onClick={e => { handleNewResearchButton(e); }}>
                            <i className="glyphicon glyphicon-plus" /> {appText('buttons.add-research')}
                        </Button>
                    </ButtonGroup>
                </div>
            </div>
        </Carousel.Item>
    ));

    const defaultActiveIndex = (_.size(carouselItems) - 1);

    const pageBody = (
        <Carousel interval={null} defaultActiveIndex={defaultActiveIndex} wrap={false}>
            {carouselItems}
        </Carousel>
    );

    return (
        <DetailFormCommon.RegionalDetailFormSection title={sectionTitle}>
            <div className="research-history-container">
                {pageBody}
            </div>
        </DetailFormCommon.RegionalDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/regional-component-lists/detail-form/component-details-research.tsx